import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { FaturaResponsavelActionsCell } from './FaturaResponsavelActionsCell'
import { FaturaList } from '../../../faturas-list/core/_models'
import { SituacaoFaturaBadge } from '../../../faturas-list/components/SituacaoFaturaBadge'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const faturaResponsavelColumns = (t: TFunction): ReadonlyArray<TableColumn<FaturaList>> => [
  // Coluna do botão de expandir (o ModernTable desenha o botão na coluna de id `expand`).
  {
    Header: () => <span className='visually-hidden'>Detalhes</span>,
    id: 'expand',
    cellWidth: '56px',
  },
  // Período de competência com a data de geração como apoio; os dois seguem ordenáveis.
  sortableColumn<FaturaList>({
    id: 'mesAno.mes',
    useQueryRequest,
    fields: [
      { field: 'mesAno.mes', label: t('cols.periodo') },
      { field: 'data', label: t('cols.data') },
    ],
    Cell: ({ row }: CellProps<FaturaList>) => {
      const { mesSigla, ano } = row.original.mesAno ?? {}
      return (
        <StackedCell
          tabular
          primary={mesSigla && ano ? `${mesSigla}/${ano}` : undefined}
          secondary={row.original.dataFormatada}
        />
      )
    },
  }),
  sortableColumn<FaturaList>({
    id: 'empresa.nomeFantasia',
    cellWidth: '220px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'empresa.nomeFantasia', label: t('cols.instituicao') }],
    Cell: ({ row }: CellProps<FaturaList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  }),
  sortableColumn<FaturaList>({
    id: 'quantidade',
    cellWidth: '136px',
    align: 'end',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'quantidade', label: t('cols.atendimentos') }],
    Cell: ({ row }: CellProps<FaturaList>) => (
      <StackedCell tabular primary={row.original.quantidade} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.valor_pagar')}</PlainHeader>,
    id: 'valorTotal',
    cellWidth: '144px',
    align: 'end',
    Cell: ({ row }: CellProps<FaturaList>) => (
      <StackedCell tabular primary={row.original.valorTotalFormatado} />
    ),
  },
  sortableColumn<FaturaList>({
    id: 'situacao',
    cellWidth: '136px',
    useQueryRequest,
    fields: [{ field: 'situacao', label: t('cols.situacao') }],
    Cell: ({ row }: CellProps<FaturaList>) => (
      <SituacaoFaturaBadge situacao={row.original.situacao} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '88px',
    align: 'end',
    Cell: ({ row }: CellProps<FaturaList>) => (
      <FaturaResponsavelActionsCell fatura={row.original} />
    ),
  },
]
